export const DBA_CATALOGS_RESET_STATE = 'DBA_CATALOGS_RESET_STATE';
export const DBA_CATALOGS_CURRENT_ITEM = 'DBA_CATALOGS_CURRENT_ITEM';

export const DBA_CATALOGS_REQUEST_LOADING = 'DBA_CATALOGS_REQUEST_LOADING';
export const DBA_CATALOGS_REQUEST_SUCCESS = 'DBA_CATALOGS_REQUEST_SUCCESS';
export const DBA_CATALOGS_REQUEST_FAILED = 'DBA_CATALOGS_REQUEST_FAILED';

export const DBA_CATALOGS_CURRENT_ACTION = 'DBA_CATALOGS_CURRENT_ACTION';
export const DBA_CATALOGS_RESET_ACTION = 'DBA_CATALOGS_RESET_ACTION';